import sha1 from "simple-sha1";
import type { Image } from "../schema/Image.js";

export function thumb(bucketUrl: string, width: number, height: number, image: Image | string): string {
	const webpPath = `${typeof image === "string" ? image : image.path}.webp`;
	const url = new URL(webpPath, "https://example.com");
	url.pathname = `/${width}x${height}${url.pathname}`;
	return `${bucketUrl}${url.pathname}?hash=${sha1.sync(url.pathname.replace("/", ""))}`;
}
